import { render, staticRenderFns } from "./classShare.vue?vue&type=template&id=57ff6230&"
import script from "./classShare.vue?vue&type=script&lang=js&"
export * from "./classShare.vue?vue&type=script&lang=js&"
import style0 from "./classShare.vue?vue&type=style&index=0&id=57ff6230&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports